import { useCallback } from 'react';
import { useAuth } from './useAuth';

// DMP-write beta (Option B — see docs/PRODUCTION-READINESS.md §9). A reusable confirmation gate shown before
// ANY action that WRITES to the real DMP, while DMP_WRITE_CONFIRM is on (temporary beta guardrail). Returns
// true to proceed, false to abort. When the flag is off it always returns true (no prompt). Native confirm,
// matching the reverse-confirmation pattern already used in the app. Reused by mapping save (Phase 1),
// Release / Un-release / back-in-scope (Phase 2), Create / Add-box (Phase 3).
export function useDmpWriteConfirm(): (label?: string) => boolean {
  const { dmpWriteConfirm } = useAuth();
  return useCallback(
    (label?: string) => {
      if (!dmpWriteConfirm) return true;
      return window.confirm(
        '⚠️ ATTENTION — écriture dans le DMP de PRODUCTION\n\n'
          + `Cette action (${label ?? 'écriture'}) va MODIFIER le vrai DMP de production, de façon réelle et immédiate.\n\n`
          + 'Confirmez-vous ?',
      );
    },
    [dmpWriteConfirm],
  );
}
